import Decimal from 'decimal.js';
import { Strategy } from '@oai-frontend-monorepo/types';
import { strategyIsCredit } from '../../strategy/strategyIsCredit';

interface Params {
  strategy?: Strategy;
  isSell?: boolean;
  mid?: Decimal;
}

const roundMid = ({ strategy, isSell, mid }: Params) => {
  if (!mid || mid === null || !strategy) {
    return mid;
  }

  const isCredit = strategyIsCredit(strategy);

  if (!isCredit) {
    return !isSell
      ? mid.toNearest(0.01, Decimal.ROUND_UP) || 0.01
      : mid.toNearest(0.01, Decimal.ROUND_DOWN) || 0.01;
  }

  return !isSell
    ? mid.toNearest(0.01, Decimal.ROUND_DOWN) || 0.01
    : mid.toNearest(0.01, Decimal.ROUND_UP) || 0.01;
};

export default roundMid;
